import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  BaseCrudComponent,
  CrudPage,
  GenericForm,
  ICrudService,
} from '@zendra/shared';
import { GisStandPerRegisterProjectionPlanningOrchestratorService } from 'orchestrator';
import {
  GisStandPerRegisterProjectionDto,
  GisStandPerRegisterProjectionExcelDownloadDto,
  GetGisStandPerRegisterProjectionListInputDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/gis-stand-per-registers/models';
import {
  GisStandPerRegisterCreateDto,
  GisStandPerRegisterUpdateDto,
} from '../proxy/geographic/dtos/gis-stand-per-register';
import { GisStandPerRegisterService } from '../proxy/geographic/controllers';
import {
  GISSTANDPERREGISTER_CONFIG,
  GISSTANDPERREGISTER_FIELDS,
} from './gis-stand-per-register.config';

@Component({
  selector: 'app-gis-stand-per-register',
  imports: [CardComponent, CardBodyComponent, CrudPage, GenericForm],
  providers: [ListService, GisStandPerRegisterService, ConfirmationService],
  templateUrl: './gis-stand-per-register.html',
  styleUrl: './gis-stand-per-register.scss',
})
export class GisStandPerRegister extends BaseCrudComponent<
  GisStandPerRegisterProjectionDto,
  GisStandPerRegisterCreateDto,
  GisStandPerRegisterUpdateDto,
  GisStandPerRegisterProjectionExcelDownloadDto
> {
  geographicService = inject(GisStandPerRegisterService);
  orchestratorService = inject(
    GisStandPerRegisterProjectionPlanningOrchestratorService
  );
  config = GISSTANDPERREGISTER_CONFIG;
  fields = GISSTANDPERREGISTER_FIELDS;

  service: ICrudService<
    GisStandPerRegisterProjectionDto,
    GisStandPerRegisterCreateDto,
    GisStandPerRegisterUpdateDto,
    GisStandPerRegisterProjectionExcelDownloadDto
  > = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.geographicService.deleteByIds(ids),
    projectionConsistency: this.createProjectionConsistency(
      this.orchestratorService,
      'gisStandPerRegisterId'
    ),
    getList: (query: GetGisStandPerRegisterProjectionListInputDto) =>
      this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input =>
      this.orchestratorService.getListAsExcelFile(input),
  };

  protected prepareUpdateDto(
    data: any,
    selected: GisStandPerRegisterProjectionDto
  ): GisStandPerRegisterUpdateDto {
    return {
      standRegisterArea: data.standRegisterArea,
      standLocationId: data.standLocationId,
      registerLocationId: data.registerLocationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GisStandPerRegister';
  }
}
